import { onUnmounted } from '@vue/composition-api';

export default function useSwipeImage(container, images, activeImageIndex) {
    let touchstartX = 0;
    let touchendX = 0;

    const onTouchStart = (event) => {
        touchstartX = event.changedTouches[0].screenX;
    };

    const onTouchEnd = (event) => {
        touchendX = event.changedTouches[0].screenX;
        processImageIndex();
    };

    function processImageIndex() {
        if (touchendX < touchstartX) {
            activeImageIndex.value = activeImageIndex.value < images.length - 1 ? ++activeImageIndex.value : images.length - 1;
        } else if (touchendX > touchstartX) {
            activeImageIndex.value = activeImageIndex.value > 0 ? --activeImageIndex.value : 0;
        }
    }

    onUnmounted(() => {
        container.removeEventListener('touchstart', onTouchStart);
        container.removeEventListener('touchend', onTouchEnd);
    });

    container.addEventListener('touchstart', onTouchStart);
    container.addEventListener('touchend', onTouchEnd);
}
